module.exports = __webpack_public_path__ + "img/PRNT_02_mono_AE_00004.ebf217fa.png";